const isEmbedded = (hostname?: string): boolean => {
  const envEmbedded = import.meta.env.VITE_EMBEDDED;
  if (envEmbedded) {
    return envEmbedded === 'true';
  }

  const host = hostname ?? window.location.hostname;
  if (!host.endsWith('.coastpay.com')) return false;
  const firstLabel = host.split('.')[0];
  return firstLabel.endsWith('-apply') || firstLabel.endsWith('-verify');
};

export { isEmbedded };
